import { GET_ALL_SIMULATION_OTP, GET_ALL_SIMULATION_OTP_SUCCESS } from "../storeTypes";

const INIT_STATE = {
    loader: false,
    simulationOTP: [],
};



const simulationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_SIMULATION_OTP:
            return {
                ...state,
                loader: true,
            };
        case GET_ALL_SIMULATION_OTP_SUCCESS:
            return {
                ...state,
                loader: false,
                simulationOTP: action.payload,
            };
        default:
            return state;
    }
}

export default simulationReducer
